// extracted by mini-css-extract-plugin
module.exports = {"comp":"EarlyBird_comp__5W_x7"};